import React, { FC, ChangeEvent } from "react";
import { LogInFormPersonType } from "@Shape-Digital/kudzu-data/lib/types/actions";
import FormControl from "../../Unknown/FormControl";
import RadioGroup from "../../Unknown/RadioGroup";
import FormControlLabel from "../../Unknown/FormControlLabel";
import Radio from "../../Unknown/Radio";
import Grid from "../../Unknown/Grid";
import Typography from "../../Unknown/Typography";
import useTranslations from "./useTranslations";

type AppointmentCheckoutFormChoiceProps = {
  personType: LogInFormPersonType | null;
  setPersonType: (type: LogInFormPersonType) => void;
  isDisabled?: boolean;
};

const AppointmentCheckoutFormChoice: FC<AppointmentCheckoutFormChoiceProps> = ({
  personType,
  setPersonType,
  isDisabled,
}) => {
  const translations = useTranslations();

  const options: { value: LogInFormPersonType; label: string }[] = [
    { value: "patient", label: translations.isPatientOption },
    { value: "familyMember", label: translations.isFamilyMemberOption },
    { value: "legalGuardian", label: translations.isLegalGuardianOption },
    { value: "otherPerson", label: translations.isOtherPersonOption },
  ];

  const onChange = (_event: ChangeEvent<HTMLInputElement>, value: string) => {
    setPersonType(value as LogInFormPersonType);
  };

  return (
    <Grid container spacing={4} direction="column">
      <Grid item>
        <Typography variant="h3">{translations.iAmLabel}</Typography>
      </Grid>
      <Grid item>
        <FormControl>
          <RadioGroup value={personType ?? ""} onChange={onChange}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                label={option.label}
                control={<Radio />}
                disabled={isDisabled}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AppointmentCheckoutFormChoice;
